import { metricsBus } from "@/common/buses";
import microsoftClarity from "@/common/services/microsoftClarity/microsoftClarity";

metricsBus.on("userFetched", ({ user }) => microsoftClarity.setUserName(user.username));

metricsBus.on("deviceTracked", ({ deviceId }) => microsoftClarity.setDeviceId(deviceId));
